import { render, staticRenderFns } from "./AvisoVideosEstatus.vue?vue&type=template&id=6134d5dc&scoped=true"
import script from "./AvisoVideosEstatus.vue?vue&type=script&lang=js"
export * from "./AvisoVideosEstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134d5dc",
  null
  
)

export default component.exports